<template>
	<a-spin :tip="spinnerLoaderLabel" size="large" :spinning="spinnerLoader">
		<div class="row">
			<!-- <div class="col-md-6">
				Cuenta
				<a-select :style="{ width: '100%' }" v-model="taxes.destination">
					<a-select-option value="pacific"> Productos </a-select-option>
					<a-select-option value="rls"> Mano de Obra </a-select-option>
				</a-select>
			</div> -->
			<div class="col-md-3">
				Plataforma
				<a-select :style="{ width: '100%' }" v-model="taxes.platform">
					<a-select-option value="381"> BBVA </a-select-option>
					<a-select-option value="197"> MercadoPago </a-select-option>
					<a-select-option value="473"> PayPal </a-select-option>
					<a-select-option value="490"> Aplazo </a-select-option>
				</a-select>
			</div>
			<div class="col-md-3">
				Monto de pago
				<a-input autocomplete="off" prefix="$" v-money="money" v-model="taxes.amount" />
			</div>
			<div class="col-md-3">
				IVA
				<a-input autocomplete="off" prefix="$" v-money="money" v-model="taxes.iva" />
			</div>
			<div class="col-md-3">
				Comprobante de pago
				<br />
				<a-upload name="file" accept="application/pdf,image/*" :file-list="filePayment" :remove="handleRemovePayment" :before-upload="beforeUploadPayment">
					<a-button> <a-icon type="upload" /> Seleccionar archivo </a-button>
				</a-upload>
			</div>
		</div>
	</a-spin>
</template>

<script>
import { mapGetters } from 'vuex'
import { VMoney } from 'v-money'
import numeral from 'numeral'
import Swal from 'sweetalert2'
//
export default {
	name: 'bankCommissionODCComponent',
	directives: {
		money: VMoney,
	},
	components: {},
	props: {
		visible: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		...mapGetters('purchaseOrders', ['spinnerLoaderLabel', 'spinnerLoader']),
	},
	data() {
		return {
			taxes: {
				amount: 0,
				iva: 0,
				type: '',
				platform: '',
				destination: 'pacific',
			},
			money: {
				decimal: '.',
				thousands: ',',
				precision: 2,
			},
			filePayment: [],
		}
	},
	methods: {
		handleRemovePayment() {
			this.filePayment = []
		},
		beforeUploadPayment(file) {
			this.filePayment = [file]
			return false
		},
		async onSaveRecord() {
			//
			let errors = []

			if (this.taxes.destination == '') {
				errors.push(`- Selecciona la cuenta a la que se refiere`)
			}
			if (numeral(this.taxes.platform).value() < 1) {
				errors.push(`- Selecciona la plataforma`)
			}
			if (numeral(this.taxes.amount).value() < 1) {
				errors.push(`- Ingresa monto a pagar`)
			}
			if (this.filePayment.length == 0) {
				errors.push(`- Ingresa el formato de pago.`)
			}

			if (errors.length) {
				Swal.fire({
					title: 'Atención',
					html: errors.join('<br>'),
					icon: 'warning',
					confirmButtonText: 'Ok',
				})
				return false
			} else {
				//
				let taxAmount = numeral(this.taxes.amount).value()
				let taxIVA = numeral(this.taxes.iva).value()
				let platform = numeral(this.taxes.platform).value()
				let formData = false
				formData = new FormData()
				formData.append('file', this.filePayment[0])
				formData.append('amount', taxAmount)
				formData.append('iva', taxIVA)

				let payload = {
					total: taxAmount + taxIVA,
					supplier_id: platform,
					payment_method_index: 0,
					elements: [
						{
							measurement_unit: 'service',
							quantity: 1,
							unit_cost: taxAmount + taxIVA,
							sku: platform == 381 ? 'BBVA-BANCA' : platform == 197 ? 'MP-COMISION' : 'PP-COMISION',
							description: `Pago de comisiones ${platform == 381 ? 'por uso de banca en línea BBVA Bancomer' : platform == 197 ? 'por ingresos a través de MercadoPago' : 'por ingresos a través de PayPal'}`,
						},
					],
					blocked: true,
					status: 1,
					is_tax: 1,
					destination: this.taxes.destination,
				}

				await this.$store.dispatch('purchaseOrders/CREATE', { payload, formData })
				this.$emit('close')
			}
		},
	},
	watch: {
		visible(isVisible) {
			if (!isVisible) {
				this.taxes = {
					amount: 0,
					type: '',
				}
				this.filePayment = []
			}
		},
	},
}
</script>
